import React from "react";
import { Row, Col, Modal, Button } from "react-bootstrap";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import { useExisteHojaDeTransporteDeHoy } from "../../../services/transporteServicios";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import EntradasSalidas from "./EntradasSalidas";
import LoadingScreen from "../../organisms/LoadingScreen";
import { useNavigate } from "react-router-dom";
import { RUTA_TRANSPORTE } from "../../../services/rutas";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/transporte",
    label: "Transporte",
  },
  {
    path: "/hoy",
    label: "Hoja diaria",
    isActive: true,
  },
];

function HojaDiariaTransporte() {
  const navigate = useNavigate();
  const {
    data: existeHojaDeTransporteDeHoy,
    isLoading: existeHojaDeTransporteDeHoyIsLoading,
    isSuccess: existeHojaDeTransporteDeHoyIsSuccess,
    error: existeHojaDeTransporteDeHoyError,
  } = useExisteHojaDeTransporteDeHoy();

  const error = existeHojaDeTransporteDeHoyError;

  if (error) {
    return <ServerErrorModal />;
  }

  if (existeHojaDeTransporteDeHoyIsLoading) {
    return <LoadingScreen isLoading={true} />;
  }

  const onVolverClick = () => {
    navigate(RUTA_TRANSPORTE);
  };

  return (
    <Page
      title="Hoja diaria de transporte"
      description="Confirmación de recogida y entrega de mascotas agendadas para hoy."
      breadCrumbs={breadCrumbs}
    >
      <Row className="justify-content-center">
        <Col className="col-xs-11 col-md-6 col-lg-4">
          {existeHojaDeTransporteDeHoy &&
            existeHojaDeTransporteDeHoyIsSuccess && <EntradasSalidas />}
          {!existeHojaDeTransporteDeHoy &&
            existeHojaDeTransporteDeHoyIsSuccess && (
              <Modal show={true} centered>
                <Modal.Header>
                  <Modal.Title>Información</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  No hay mascotas a transportar el día de hoy
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={onVolverClick}>Volver</Button>
                </Modal.Footer>
              </Modal>
            )}
        </Col>
      </Row>
    </Page>
  );
}

export default HojaDiariaTransporte;
